import React from 'react';
import * as PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import styleConstants from '../../../styleConstants';

const useStyles = makeStyles({
	container: {
		paddingBottom: styleConstants.componentSpacing
	}
});

const FigureOnly = props => {
	const classes = useStyles(props);

	return <div className={classes.container}>{props.children}</div>;
};

FigureOnly.propTypes = {
	children: PropTypes.oneOfType([
		PropTypes.node,
		PropTypes.arrayOf(PropTypes.node)
	])
};

export default FigureOnly;
